import { ReactElement } from 'react';
import Procard from './Procard';
import Header from './Header';

/**
 * InsightsWidget component for displaying insights.
 * @returns  A React element representing the Insight component.
 */
export default function InsightsWidget(): ReactElement {
  return (
    <div className="p-4 rounded shadow-md dark:bg-container-500 flex flex-col flex-1">
      <Header sectionName="Insights" showIcon>
        <Procard />
      </Header>
      <div className="flex flex-col flex-1 gap-3">
        <div>
          <p className="text-xs font-medium dark:text-gray-300 mt-3">Ventilation Status</p>
          <img src="/assets/graph.svg" className="scale-x-[-1] blur-md mt-[-15px]" alt="graph" />
        </div>
        <div>
          <p className="gray-900 text-xs font-medium my-4 dark:text-gray-300">Emission Rate</p>
          <img src="/assets/graph.svg" className="scale-x-[-1] blur-md mt-[-15px]" alt="graph" />
        </div>
        {/* <div>
          <p className="text-gray-900 text-xs font-medium mb-4 py-2 dark:text-gray-300">
            Air Exchange Rate
          </p>
          <img src="/assets/graph.svg" className="scale-x-[-1] blur-md mt-[-15px]" alt="graph" />
        </div> */}
      </div>
    </div>
  );
}
